"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lexbot = void 0;
exports.lexbot = ['Legacy bot', 'Search & Message Bot (cb_message_search_only)', 'Custom bot'];
